import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKai = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 7.99991,
			cy: 7.99996,
			rx: 7.99991,
			ry: 7.99996,
			fill: "var(--first-color-kai-icon, #b791c0)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 0,
			y: 0,
			width: 0,
			height: 0,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(0px)",
					clipPath: "url(#bgblur_0_114189_28199_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 0,
			d: "M4.45107 3.448C2.66567 3.448 0.902344 4.81371 0.902343 7.05676C0.902343 11.0368 4.08594 14.2743 7.99979 14.2743C11.9136 14.2743 15.0972 11.0368 15.0972 7.05676C15.0972 4.8057 13.3319 3.448 11.5485 3.448C10.0245 3.448 8.7261 4.3971 8.17486 5.74357C8.11059 5.89955 7.88899 5.89955 7.82512 5.74357C7.27349 4.3971 5.97505 3.448 4.45107 3.448Z",
			fill: "var(--second-color-kai-icon,#EDE3EF)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.13391 9.33879C9.13391 10.0885 8.48718 10.8899 8.18239 11.226C8.09137 11.3264 7.96246 11.3264 7.87144 11.226C7.56665 10.8899 6.91992 10.0885 6.91992 9.33879C6.91992 8.79702 7.41561 8.35791 8.02692 8.35791C8.63822 8.35791 9.13391 8.79702 9.13391 9.33879Z",
			fill: "var(--first-color-kai-icon, #b791c0)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.5127,
			y: 5.73364,
			width: 1.30525,
			height: 2.55932,
			rx: .144655,
			transform: "rotate(1.58343 3.5127 5.73364)",
			fill: "var(--first-color-kai-icon, #b791c0)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.27433 13.1072C7.59837 13.3352 6.85927 13.8823 6.44922 14.1274C6.44922 14.2174 8.05448 14.8325 8.60957 14.4424C9.16467 14.0523 8.1595 13.5723 8.24951 13.6473C8.32152 13.7073 8.14949 13.9923 8.05448 14.1274C8.10249 13.6233 7.55438 13.2372 7.27433 13.1072Z",
			fill: "var(--first-color-kai-icon, #b791c0)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4393 5.892L10.315 7.04182C10.2706 7.08726 10.269 7.15941 10.3115 7.20668L11.3925 8.40913C11.4147 8.4338 11.4461 8.44825 11.4792 8.44905L12.4243 8.47192C12.53 8.47448 12.5875 8.34944 12.5169 8.27082L11.588 7.23758C11.5455 7.19031 11.547 7.11816 11.5914 7.07271L12.5587 6.08348C12.6324 6.00816 12.5808 5.88124 12.4755 5.87869L11.5284 5.85577C11.495 5.85496 11.4627 5.86808 11.4393 5.892Z",
			fill: "var(--first-color-kai-icon, #b791c0)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "bgblur_0_114189_28199_clip_path",
			transform: "translate(0 0)",
			children: /* @__PURE__ */ _jsx("path", { d: "M4.45107 3.448C2.66567 3.448 0.902344 4.81371 0.902343 7.05676C0.902343 11.0368 4.08594 14.2743 7.99979 14.2743C11.9136 14.2743 15.0972 11.0368 15.0972 7.05676C15.0972 4.8057 13.3319 3.448 11.5485 3.448C10.0245 3.448 8.7261 4.3971 8.17486 5.74357C8.11059 5.89955 7.88899 5.89955 7.82512 5.74357C7.27349 4.3971 5.97505 3.448 4.45107 3.448Z" })
		}) })
	]
});
const ForwardRef = forwardRef(SvgKai);
export { ForwardRef as ReactComponent };
